export default __webpack_public_path__ + "static/favicon-0c1f3a43589bbaf89459a4491ba89dbe.ico";